
const digest = '8c9420980dffe96980baf913d5c2275ffedce6bba155c1c4d2e33a18fad4020a';
const classes = {"scrollbarWrapper":"_scrollbar-wrapper_1mh9j_1"};
const css = `._scrollbar-wrapper_1mh9j_1 {
  width: 100%;
  overflow: hidden;
  overflow-x: auto;
  height: 20px;
  -ms-overflow-style: auto;
  scrollbar-width: 6px;
  cursor: pointer;
}
._scrollbar-wrapper_1mh9j_1::-webkit-scrollbar {
  display: block;
}
._scrollbar-wrapper_1mh9j_1::-webkit-scrollbar {
  width: 4px;
  height: 6px;
  padding: 2px;
  cursor: pointer;
}
._scrollbar-wrapper_1mh9j_1::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._scrollbar-wrapper_1mh9j_1::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
  cursor: pointer;
}
._scrollbar-wrapper_1mh9j_1::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  